import React, { useEffect,useState } from "react";
import logo from "../assets/logo/Logo.png";
import google from "../assets/logo/google.png";
import facebook from "../assets/logo/facebook.png";
import apple from "../assets/logo/apple.png";
import Carousel from "./carousel/logincarousel";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import bannerlayout from "../assets/images/banner-layout.png";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

export default function Signinwithmobile() {
  const [formData, setFormData] = useState({

    mobile: "",
    countryCode: "+91", // Default country code
  });
    const [showOTPModal, setShowOTPModal] = useState(false);
   const [timer, setTimer] = useState(300); // 5 minutes (300 seconds)
  const [canResend, setCanResend] = useState(false);
  
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setCanResend(true); // Enable "Resend OTP" when timer reaches 0
    }
  }, [timer]);
  
  // Format time as MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };
  
  
  const countryOptions = [
    { code: "US", name: "United States", dialCode: "+1", flagUrl: "https://flagcdn.com/w40/us.png" },
    { code: "GB", name: "United Kingdom", dialCode: "+44", flagUrl: "https://flagcdn.com/w40/gb.png" },
    { code: "CA", name: "Canada", dialCode: "+1", flagUrl: "https://flagcdn.com/w40/ca.png" },
    { code: "AU", name: "Australia", dialCode: "+61", flagUrl: "https://flagcdn.com/w40/au.png" },
    { code: "DE", name: "Germany", dialCode: "+49", flagUrl: "https://flagcdn.com/w40/de.png" },
    { code: "FR", name: "France", dialCode: "+33", flagUrl: "https://flagcdn.com/w40/fr.png" },
    { code: "JP", name: "Japan", dialCode: "+81", flagUrl: "https://flagcdn.com/w40/jp.png" },
    { code: "CN", name: "China", dialCode: "+86", flagUrl: "https://flagcdn.com/w40/cn.png" },
    { code: "IN", name: "India", dialCode: "+91", flagUrl: "https://flagcdn.com/w40/in.png" },
    { code: "BR", name: "Brazil", dialCode: "+55", flagUrl: "https://flagcdn.com/w40/br.png" },
  ];
  const [selectedMethod, setSelectedMethod] = useState("email"); // Default: email

  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Hook for navigation
  const API_URL = "https://pipaan.com360degree.com/api/auth";

  // ✅ Handle Google Login
  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/google`;
  };

  // ✅ Handle Facebook Login
  const handleFacebookLogin = () => {
    window.location.href = `${API_URL}/facebook`;
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "56px",
      borderRadius: "20px",
      border: "0.5px solid #095228",
      padding: "5px",
    }),
    control: (base) => ({
      ...base,
      minWidth: 100,
      minHeight: "100%",
      borderRadius: "12px",
      border: "0.5px solid #095228",
      padding: "10px 5px",
    }),
    option: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures it appears on top
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));


  };
  const handleCountryChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      countryCode: selectedOption.dialCode, // Update the country code
    }));
  };


  const handleSendMobileOTP = async (e) => {
    e.preventDefault();
  
    if (!formData.mobile) {
      alert("Please enter your mobile number.");
      return;
    }
  
    const formattedMobile = `${formData.countryCode}-${formData.mobile}`;
  
    const requestData = { mobile_number: formattedMobile };
  
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/phone-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
  
      const data = await response.json();
      if (response.ok && data.success) {
        const token = data.result?.token; // Extract token from response
        if (token) {
          sessionStorage.setItem("accessTokenMobile", token); // Store token in sessionStorage
          console.log("✅ Token saved for mobile:", token);
        }
        alert(`OTP has been sent to your mobile number: ${formattedMobile}`);
        setShowOTPModal(true); // Show OTP modal
      } else {
        alert(`Please enter a registered mobile number. ${data.result?.message || "Try again."}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
 
  const handleSubmitVerify = async (e) => {
    e.preventDefault();
    const storedEmail = sessionStorage.getItem("userEmail");
    if (!storedEmail) {
      alert("No email found. Please sign up again.");
      return;
    }
    const token = sessionStorage.getItem("accessTokenMobile");  // ✅ Retrieve token from sessionStorage
    if (!token) {
        setError("Authentication token is missing. Please log in again.");
        return;
    }

    const requestData = {
      email: storedEmail,  // Email entered by the user
      otp: code, 
      token: token  // ✅ Send token in the body

      // verifying:"mobile_number"    // Verification code entered by the user
    };

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/verify-phone-login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        console.log("Verification Successful:", data);
        // alert("Verification Successful! Please log in.");

        // Redirect to login page
        navigate("/home");
      } else {
        console.error("Verification Failed:", data);
        alert(`Verification failed: ${data.result?.message || "Invalid code. Please try again."}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };


 
  const handleGenerateOTP = async (e) => {
    e.preventDefault();
  
    if (!formData.mobile.trim()) {
      setError("Please enter your mobile number."); // ✅ Show error message
      return;
    }
    setError(null); // Clear previous errors

   

    const formattedMobile = `${formData.countryCode}-${formData.mobile}`;
 const requestData = { 
        mobile_number: formattedMobile,
    };
  
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/phone-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
  
      const data = await response.json();
      if (response.ok && data.success) {
          const token = data.result?.token;  // ✅ Extract token from response

          if (token) {
              sessionStorage.setItem("accessTokenMobile", token);  // ✅ Store token in sessionStorage
              console.log("✅ Token saved for mobile:", token);
            }
        alert(`OTP has been sent to your mobile number: ${formattedMobile}`);
        setShowOTPModal(true); // ✅ Show OTP modal only after successful OTP send

      } else {
        setError(`Please enter a registered mobile number. ${data.result?.message || " Try again."}`);
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Something went wrong. Please try again.");
    }
    
  };
  
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
  
    if (!formData.mobile) {
      alert("Please enter your mobile number.");
      return;
    }
    if (!code) {
      alert("Please enter the OTP.");
      return;
    }
    const token = sessionStorage.getItem("accessTokenMobile");  // ✅ Retrieve token from sessionStorage
    if (!token) {
        setError("Authentication token is missing. Please log in again.");
        return;
    }
    const formattedMobile = `${formData.countryCode}-${formData.mobile}`;
    const requestData = {
      mobile_number: formattedMobile,  // API expects "email", but we're passing the mobile number
      otp: code, 
      token: token  // ✅ Send token in the body

      // Include the OTP entered by the user
    };
  
  
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/verify-phone-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
  
      const data = await response.json();
      if (response.ok) {
        console.log("Login Success:", data);
        // Store token if provided
        if (data.token)
          localStorage.setItem("authToken", data.token);

        const accessToken = data.result.token?.refresh?.token;
        console.log("Access Token:", accessToken);

        // console.log("Token stored in LocalStorage:", localStorage.getItem("accessToken"));

        sessionStorage.setItem("accessToken", accessToken);
        console.log("Stored Token:", sessionStorage.getItem("accessToken"));

        console.log("API Response:", accessToken);
        console.log("Token Received:", accessToken);

        // ✅ Store user details
        const user = data.result?.user;

        if (user) {
          sessionStorage.setItem("user", JSON.stringify(user)); // Store user in sessionStorage
          // localStorage.setItem("user", JSON.stringify(user)); // Optional: Store in localStorage
          console.log("User Data Stored:", sessionStorage.getItem("user"));
        } else {
          console.error("User data is missing in response");
        }

        // Redirect to home page
        navigate("/home");
      }  else {
        alert(`Verification failed: ${data.result?.message || "Invalid code. Please try again."}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  
  // Carousel login
  let slides = [
    loginbanner,
    loginbannertwo,
    loginbannerthree,
    loginbannerfour
  ];
  let slidessm = [
    loginbannersm,
    loginbannersm,
    loginbannersm,
    loginbannersm,
  ];

  return (
    <div className="login">
      <div className="container min-h-screen flex">
        {/* Left side image */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="carousel-size pb-3 pt-3 ">
            <Carousel slides={slides} />
            {/* <!-- Overlay Image --> */}
            <img src={bannerlayout} alt="Overlay" class="layout" />
          </div>
          <div className="copy-rights py-6 text-center text-sm text-[#095228]">
            © 2025 Pipaan. All Rights Reserved
          </div>
        </div>
        {/* Right side login form */}
        <div className=" w-full lg:w-1/2 login-content flex flex-col">
          <div className="lg:hidden">
            <div className="carousel-size pb-3 pt-3 ">
              <Carousel slides={slidessm} />
              {/* <!-- Overlay Image --> */}
              <img src={bannerlayout} alt="Overlay" class="layout" />
            </div>
          </div>
          <div className="login-form">
            {/* Language selector */}
            <div className="flex justify-end">

              <Menu as="div" className="language-btn relative inline-block text-left">
                <div>
                  <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm align-center  hover:bg-gray-50">
                    English
                    <svg width="10" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.92 0.179932H6.68999H1.07999C0.119992 0.179932 -0.360007 1.33993 0.319993 2.01993L5.49999 7.19993C6.32999 8.02993 7.67999 8.02993 8.50999 7.19993L10.48 5.22993L13.69 2.01993C14.36 1.33993 13.88 0.179932 12.92 0.179932Z" fill="#292D32" />
                    </svg>
                  </MenuButton>
                </div>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <div className="py-1">
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <form action="#" method="POST">
                      <MenuItem>
                        <button
                          type="submit"
                          className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                        >
                        </button>
                      </MenuItem>
                    </form>
                  </div>
                </MenuItems>
              </Menu>
            </div>
            {/* Main Content */}
            <div className="reset-pass flex flex-col items-center justify-center px-6">
              {/* Logo */}
              <div className=" logo">
                <img
                  src={logo}
                  alt="Pipaan Logo"
                  width={150}
                  height={50}
                />
              </div>

              {/* Back to Login */}
              <div className="w-full max-w-md">
                <Link to="/login" className="back-to-login text-[#313131] text-sm flex items-center mb-4">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"></path>
                  </svg>
                  Back to login
                </Link>

                {/* Verification Form */}
                <div className="w-full">
                  <h1 className="login-title text-2xl font-semibold text-left mb-5">Login With Mobile Number</h1>


                  <form onSubmit={handleSendMobileOTP} className="space-y-4 mb-10 frg-pass-content">
                    {/* Phone Number Input */}
                    <div className="space-y-3 pb-5">
                      <label className="text-sm font-medium" htmlFor="mobile">
                        Mobile Number
                      </label>
                      <div className="flex space-x-3 items-center">
                        <Select
                          options={countryOptions}
                          getOptionLabel={(e) => (
                            <div className="flex items-center">
                              <img src={e.flagUrl} alt="" className="w-6 h-auto" />
                              <span className="ml-2 hidden">{e.dialCode}</span>
                            </div>
                          )}
                          getOptionValue={(e) => e.dialCode}
                          value={countryOptions.find((c) => c.dialCode === formData.countryCode)}
                          onChange={handleCountryChange}
                          styles={customStyles}
                          menuPortalTarget={document.body} // Ensures popup behavior
                          menuPosition="absolute"
                        />

                        <input
                          id="mobile"
                          placeholder="Mobile Number"
                          type="tel"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          className="w-full px-3 py-4 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                        />
                      </div>
 {/* ✅ Show error below input field if empty */}
 {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

                    </div>

                    {/* {error && <p className="text-red-500 text-sm">{error}</p>} */}

                    <button
                      type="submit"
                      onClick={handleGenerateOTP} // ✅ Calls function to check mobile input before opening modal

                      className="w-full bg-[#1B2537] hover:bg-[#1B2537]/90 text-[#FFFFFF] py-3 rounded-xl font-medium "
                    >
                      Login Using OTP                    </button>

                 

                  </form>


  {/* OTP Modal */}
  {showOTPModal && (
                    <div className="fixed inset-0 flex items-center justify-center  bg-[#fff] backdrop-blur bg-opacity-50">
                      <div className="bg-white p-6  md:pl-[5%] md:pr-[5%] md:pb-[3%] rounded-lg shadow-lg relative">
                        {/* Close Button */}
                        <button
                          className="hidden md:block absolute top-2 right-2 text-[#fff] hover:text-[#fff] bg-[#095228] rounded-full p-1 pl-2.5 pr-2.5"
                          onClick={() => setShowOTPModal(false)}
                        >
                          ✖
                        </button>

                        {/* Forgot Password Form */}
                        <h2 className="login-title text-base font-medium text-center mt-2 mb-6 ">
                          OTP Verification
                        </h2>

                        <form onSubmit={handleSubmitVerify} className="space-y-4 frg-pass-content">
                          {/* Radio Buttons for Selection */}
                          <div className="flex justify-around space-x-4 mb-4">
                            {/* <label className="flex items-center space-x-2 cursor-pointer">
                              <input
                                type="radio"
                                name="recoveryMethod"
                                value="email"
                                checked={selectedMethod === "email"}
                                onChange={() => setSelectedMethod("email")}
                                className="w-4 h-4 border-[#095228] rounded-full focus:ring-green-500"
                              />
                              <span className="text-base text-[#344054]">Email</span>
                            </label> */}

                            {/* <label className="flex items-center space-x-2 cursor-pointer">
                              <input
                                type="radio"
                                name="recoveryMethod"
                                value="phone"
                                checked={selectedMethod === "phone"}
                                onChange={() => setSelectedMethod("phone")}
                                className="w-4 h-4"
                              />
                              <span className="text-base text-[#344054]"></span>
                            </label> */}
                          </div>
                          <button
                            type="submit"
                            onClick={handleGenerateOTP} // Call function to send OTP

                            className="w-full bg-[#1B2537] hover:bg-[#1B2537]/90 text-white py-3 rounded-xl font-medium"
                          >
                            Generate OTP
                          </button>
                          {/* Conditional Input Field */}
                          <div>
                            <label className="text-[12px] text-[#80807F] font-small block mt-9 mb-2">Enter the verification code we just sent to your mobile;
                              {/* {selectedMethod === "email" ? "Email" : "Phone Number"} */}
                            </label>
                            <input
                              // type={selectedMethod === "email" ? "email" : "tel"}
                              placeholder={selectedMethod === "email" ? "Enter Verification Code" : "Enter Verification Code"}
                              value={code}
                              onChange={(e) => setCode(e.target.value)}
                              className="mb-4 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none"
                              required
                            />
                          </div>

                          {/* Signup Link */}
                          <div className="vrfy-code-valid ">
                            {/* <num className="timer">05.00</num> */}
                            <p className="text-lg font-bold text-red-500">{formatTime(timer)}</p>

                          </div>
                          <p className=" text-center text-sm text-gray-600 ">
                            Didn’t receive a code?{" "}
                            {/* <Link to="/signup" className="text-[#095228] font-medium hover:underline">
                              Resend
                            </Link> */}
                            <button
                              onClick={handleSendMobileOTP} // Call new function to resend OTP
                              className="text-[#095228] font-medium hover:underline"
                            >
                              Resend
                            </button>
                          </p>
                          <button
                            type="submit"
                            onClick={handleVerifyOTP} // Call function to verify OTP

                            className="w-full bg-[#80807F] hover:bg-[#1B2537]/90 text-white py-3 rounded-xl font-medium mb-10"
                          >
                            Verify
                          </button>
                          {/* Close Button */}
                          <button
                            className="md:hidden w-full bg-[#161F28] hover:bg-[#1B2537]/90 text-white py-3 rounded-xl font-medium mb-10"
                            onClick={() => setShowOTPModal(false)}
                          >
                            Cancel
                          </button>
                        </form>
                      </div>
                    </div>
                  )}
                  <div className="relative mt-6 mb-6">
                      <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-gray-200"></div>
                      </div>
                      <div className="relative flex justify-center text-sm">
                        <span className="bg-[#FAFAFA] px-2 text-gray-500 ">
                          Or
                        </span>
                      </div>
                    </div>
                    <button type="submit" onClick={() => navigate("/login")}
                      className="w-full bg-[#1B2537] hover:bg-[#1B2537]/90 text-[#FFFFFF] py-3 rounded-xl font-medium "
                    >                  Login with Email
                    </button>
                  {/* Social Login */}
                  <div className="relative my-6">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-gray-200"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="bg-white px-2 text-gray-500">Login With</span>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-4 mb-10">
                    <button className="w-full rounded-lg " onClick={handleGoogleLogin}>
                      <img
                        src={google}
                        alt="Facebook"
                        className=" mx-auto" />
                    </button>
                    <button className="w-full rounded-lg " onClick={handleFacebookLogin}>
                      <img
                        src={facebook}
                        alt="Facebook"
                        className=" mx-auto"
                      />
                    </button>
                    <button className="w-full rounded-lg ">
                      <img
                        src={apple}
                        alt="Apple"
                        className=" mx-auto"
                      />
                    </button>

                  </div>
                  {/* Signup Link */}
                  <p className="text-center text-sm text-[#313957] mt-4">
                    Don't you have an account?{" "}
                    <Link to="/signup" className="text-[#006838] font-medium hover:underline">
                      Create New Account
                    </Link>
                  </p>
                  {/* Footer */}
                  <div className="lg:hidden">

                    <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                      © 2025 Pipaan. All Rights Reserved
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
